var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78701 1.5162C8.87084 1.33444 9.12916 1.33445 9.21299 1.51619L10.9373 5.25454C11.2628 5.96023 11.9316 6.44612 12.7033 6.53762L16.7916 7.02235C16.9903 7.04591 17.0701 7.29159 16.9232 7.42748L13.9007 10.2226C13.3301 10.7503 13.0747 11.5365 13.2261 12.2987L14.0284 16.3366C14.0674 16.5329 13.8585 16.6848 13.6838 16.587L10.0915 14.5762C9.41332 14.1966 8.58668 14.1966 7.90855 14.5762L4.31619 16.587C4.14153 16.6848 3.93255 16.5329 3.97156 16.3366L4.77389 12.2987C4.92535 11.5365 4.6699 10.7503 4.09934 10.2226L1.07681 7.42748L0.397855 8.16166L1.07681 7.42748C0.929855 7.29158 1.00968 7.04591 1.20844 7.02235L5.29667 6.53762C6.0684 6.44612 6.73717 5.96023 7.06267 5.25454L8.78701 1.5162Z",
    fill: "#FF6633",
    stroke: "#FF6633",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite-icon.f34b8377d3f4ad055bd6aeff8488af25.svg";
export { ForwardRef as ReactComponent };